import SPModuleLoader from './SPModuleLoader';

export default class SPModuleLoaderProvider {
  private static _instance: SPModuleLoader;

  public static get instance(): SPModuleLoader {
    if (!this._instance) {
      this._instance = new SPModuleLoader();
    }

    return this._instance;
  }
}


// WEBPACK FOOTER //
// /src/SPModuleLoaderProvider.ts